export function isTemporaryLiveTrackPage(pathname = window.location.pathname) {
  return pathname.startsWith('/fleet/live-track/')
}
